<template>
  <div class="bar-chart">
    <div v-if="draw">
      <canvas :id="`${id}`" data-action="view_perf_bar"></canvas>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  name: "bar-chart",
  props: {
    data: {
      type: [Object, Array],
      default: null
    },
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      draw: true
    };
  },
  watch: {
    data() {
      if (this.data.length > 0) {
        this.draw = true;
        this.createChart(this.id, this.data);
      } else {
        this.draw = false;
      }
    }
  },
  methods: {
    createChart(chartId, chartData) {
      if (chartData) {
        var ctx = document.getElementById(chartId);
        new Chart(ctx, {
          type: "bar",
          data: {
            datasets: [
              {
                data: chartData.map(item => {
                  return item.value;
                }),
                backgroundColor: chartData.map(item => {
                  return item.value > 0
                    ? "rgba(91, 181, 153, 0.51)"
                    : "rgba(218, 22, 22, 0.4)";
                }),
                borderColor: chartData.map(item => {
                  return item.value > 0 ? "#25af84" : "#da1616";
                }),
                borderWidth: 1.1
              }
            ],
            labels: chartData.map(item => {
              return item.year;
            })
          },
          options: {
            tooltips: {
              callbacks: {
                label: function(tooltipItem) {
                  return " " + tooltipItem.yLabel.toFixed(2) + " %";
                }
              }
            },
            legend: { display: false },
            scales: {
              yAxes: [
                {
                  gridLines: {
                    display: true,
                    lineWidth: 1,
                    color: "#F9F9F9"
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "% ผลตอบแทน",
                    fontFamily: "Helvetica"
                  }
                }
              ],
              xAxes: [
                {
                  barPercentage: 0.5,
                  gridLines: {
                    display: false
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "ปีของผลตอบแทน",
                    fontFamily: "'Helvetica'"
                  }
                }
              ]
            }
          }
        });
      }
    }
  }
};
</script>